module.exports = __webpack_public_path__ + "static/media/spring-original.617fb499.svg";